/*eslint-disable*/
import {commonApi, common} from '@/common/index'
import {mapState} from 'vuex'

const gamePageBanner = {
  computed: {
    ...mapState({
      firstNav: state => state.firstNav,
    })
  },
  watch: {
    firstNav() {
      if(this.firstNav.length){
        this.getBannerList()
      }
    }
  },
  methods: {
    getBannerList() {
      if(this.firstNav.length) {
        let id = 0;
        this.firstNav.forEach((item) => {
          if(item.type===this.nowNavIndex) {
            id = item.id
          }
        });
        commonApi.HOMEBEFORE.getBannerList(id)
          .then((list) => {
            this.banner = list[0].picLink
          })
          .catch(err => {})
      }
    },
  },
  mounted() {
    if(this.firstNav.length){
      this.getBannerList()
    }
  }
};
export default gamePageBanner



// WEBPACK FOOTER //
// ./src/common/mixins/banner/gameBannerMixin.js